<template>
  <div :class="bem('wrapper')">
    <StravaHeadlineImage
      :class="bem('headline-image')"
      :headline-image="data.headlineImage"
      :badge-image="data.badgeImage"
      :view="view"
    />
    <div :class="bem('content')">
      <GenericStructuredText
        v-if="data.formTitleSection"
        :content="data.formTitleSection"
        copy-size="body-sm"
      />
      <div :class="bem('form')">
        <StravaForm
          v-if="view === 'form'"
          :content="data"
        />
        <StravaVerificationRequired
          v-else-if="view === 'verification-required'"
          :content="data"
        />
        <StravaVerifying
          v-else-if="view === 'verifying'"
          :slug="data.competition.slug"
          :competition-id="data.competition.competitionId"
        />
        <StravaConfirming
          v-else-if="view === 'confirming'"
          :slug="data.competition.slug"
          :competition-id="data.competition.competitionId"
        />
        <StravaCodeSnippet
          v-else-if="view === 'code'"
        />
      </div>
      <GenericStructuredText
        v-if="data.formTerms"
        :content="data.formTerms"
        copy-size="body-sm"
        :class="bem('terms')"
      />
    </div>
  </div>
  <div
    v-if="code && data.stickyButtonText"
    :class="bem('sticky-btn')"
  >
    <StravaShopNow>
      {{ data.stickyButtonText }}
    </StravaShopNow>
  </div>
</template>

<script setup>
const bem = useBEM('StravaView')
const route = useRoute()
const code = route.query.code

defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  view: {
    type: String,
    default: 'form'
  }
})
</script>

<style lang="postcss">
.StravaView__wrapper {
  @apply relative pt-[10vh] pb-6 md:pb-[5vh] mt-auto mb-auto;

  @screen md {
    @apply flex gap-8 justify-center items-center;
  }

  @screen xl {
    @apply gap-x-16;
  }
}

.StravaView__headline-image {
  @apply w-10/12;

  @screen mdMax {
    @apply mx-auto;
  }

  @screen md {
    @apply max-w-[25rem];
  }

  @screen xxl {
    @apply max-w-[28rem];
  }
}

.StravaView__content {
  @screen mdMax {
    @apply mt-4 max-w-[25rem] mx-auto;
  }

  @screen xl {
    @apply max-w-[30rem];
  }
}

.StravaView__form {
  @apply relative bg-white rounded-lg shadow-md mt-4 m-auto;
}

.StravaView__headline-image,
.StravaView__form {
  @apply mdMax:max-w-sm;
}

.StravaView__headline-image,
.StravaView__content {
  @screen md {
    @apply w-1/2;
  }
}

.StravaView__sticky-btn {
  @apply hidden md:block absolute bottom-4 mb-8 mt-4 left-1/2 -translate-y-1/2;

  animation-delay: 0.2s;
}

.StravaView__form,
.StravaView__terms {
  @apply p-4;
}

.StravaView__headline-image,
.StravaView__content,
.StravaView__sticky-btn {
  opacity: 0;
  transform: translateY(2rem);
  animation-name: content-entrance;
  animation-duration: 0.75s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
}

@keyframes content-entrance {
  0% {
    opacity: 0;
    transform: translateY(2rem);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>